import { render, staticRenderFns } from "./MarketReports.vue?vue&type=template&id=baa2bcd2&scoped=true&"
import script from "./MarketReports.vue?vue&type=script&lang=js&"
export * from "./MarketReports.vue?vue&type=script&lang=js&"
import style0 from "./MarketReports.vue?vue&type=style&index=0&id=baa2bcd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa2bcd2",
  null
  
)

export default component.exports